import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/login.jpeg';

const _withScopeId = n => (_pushScopeId("data-v-13f841fa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login-page"
};
const _hoisted_2 = {
  class: "login-box"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-box-header"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "header-bg",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "login-box-title"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title-text"
}, "登 录")])], -1));

const _hoisted_4 = {
  class: "login-form-page"
};
const _hoisted_5 = {
  class: "login-form-confirm"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "15px"
  }
}, "版权所有：广州市护新家科技有限公司"), /*#__PURE__*/_createElementVNode("span", null, "备案号："), /*#__PURE__*/_createElementVNode("a", {
  class: "footer_text",
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "粤ICP备2022153796号-1")], -1));

import { onMounted, reactive, ref } from 'vue';
import ComForm from '@/components/common/ComForm.vue';
import { ElMessage } from 'element-plus';
import { login } from '@/api/system';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import { getOpenId } from "@/api/system";
export default {
  __name: 'login',

  setup(__props) {
    const store = useStore(),
          router = useRouter();
    ;
    const pageLoad = ref(); // 总账号：18124017683

    const formConfig = reactive({
      span: 24,
      fields: [{
        name: 'phone',
        label: '手机号',
        type: 'text'
      }, {
        name: 'password',
        label: '密码',
        type: 'password'
      }]
    });
    const formData = ref({});
    const remember = ref(false);
    let openId;
    const buttonList = reactive([{
      text: '登 录',
      round: true,
      click: () => {
        let params = formData.value;

        if (!params.phone || !params.password) {
          ElMessage.error('手机号和密码不能为空');
          return;
        }

        if (openId) params.openId = openId;
        pageLoad.value = true;
        login(params).then(res => {
          if (remember.value) localStorage.setItem('login', params.phone);
          let resData = res.data || {};
          delete resData.password;
          store.commit('user/setUser', resData);
          localStorage.setItem('user', JSON.stringify(resData));
          router.push('index');
        }).finally(() => {
          pageLoad.value = false;
        });
      }
    }]);

    const openIdInfo = () => {
      pageLoad.value = true;
      const code = sessionStorage.getItem('code');
      getOpenId({
        code
      }).then(res => {
        // console.log(res);
        if (res.status == 0) {
          openId = res.data;
          sessionStorage.setItem('myOpenId', openId);
        }

        pageLoad.value = false;
      });
    };

    onMounted(() => {
      if (store.state.appData.isWeixin) openIdInfo(); // 获取当前微信用户的openId（为微信支付做准备）

      if (localStorage.getItem('user')) {
        router.push('index');
      } else {
        const phone = localStorage.getItem('login');

        if (phone) {
          formData.value.phone = phone;
          remember.value = true;
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_com_button = _resolveComponent("com-button");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(ComForm, {
        config: formConfig,
        modelValue: formData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value = $event)
      }, null, 8, ["config", "modelValue"]), _createVNode(_component_el_checkbox, {
        modelValue: remember.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => remember.value = $event),
        label: "记住手机号",
        size: "large"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_com_button, {
        list: buttonList
      }, null, 8, ["list"])])])]), _hoisted_6])), [[_directive_loading, pageLoad.value]]);
    };
  }

};